/**
 * Moves [New] — hover/focus card visuals + click-to-bind CTA link
 * Timings match Moves.jsx (EASE, bg 1s / scale 6s, heading 0.55s, reveal 0.7s)
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'moves-new';
  var EASE_MS = 550;
  var instances = new WeakMap();

  function MovesNew(root) {
    this.root = root;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-moves-card]'));
    this.bgPanels = Array.prototype.slice.call(root.querySelectorAll('[data-moves-bg]'));
    this.headingEl = root.querySelector('[data-moves-heading-el]');
    this.cta = root.querySelector('[data-moves-cta]');
    this.defaultCtaHref =
      (this.cta && (this.cta.getAttribute('data-moves-cta-default') || this.cta.getAttribute('href'))) || '#';
    this.stage = root.querySelector('[data-moves-stage]');
    this.defaultHeading = root.getAttribute('data-default-heading') || 'Discover by Family';
    this.active = null;
    this.selected = null;
    this.headingTimer = null;
    this.reducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.reducedMotion) root.classList.add('is-reduced-motion');

    this.bind();
    this.observeReveal();
    this.setActive(null, true);
  }

  MovesNew.prototype.bind = function () {
    var self = this;

    this.cards.forEach(function (card) {
      var index = parseInt(card.getAttribute('data-moves-card'), 10);

      card.addEventListener('mouseenter', function () {
        self.setActive(index);
      });

      card.addEventListener('focus', function () {
        self.setActive(index);
      });

      card.addEventListener('click', function () {
        self.applyCta(index);
        self.setActive(index);
      });
    });

    if (this.stage) {
      this.stage.addEventListener('mouseleave', function () {
        self.setActive(self.selected);
      });
    }
  };

  MovesNew.prototype.observeReveal = function () {
    var self = this;
    if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
      this.cards.forEach(function (card) {
        card.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
          window.setTimeout(function () {
            el.classList.add('is-inview');
          }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    this.cards.forEach(function (card) {
      observer.observe(card);
    });

    this.revealObserver = observer;
  };

  MovesNew.prototype.setActive = function (index, instant) {
    if (index === this.active && !instant) return;
    this.active = index;

    this.cards.forEach(function (card, i) {
      card.classList.toggle('is-active', i === index);
    });

    var bgKey = index === null ? 'default' : String(index);
    this.bgPanels.forEach(function (panel) {
      var key = panel.getAttribute('data-moves-bg');
      var on = key === bgKey;
      var wasActive = panel.classList.contains('is-active');
      if (on) {
        panel.classList.add('is-active');
        panel.classList.remove('is-exiting');
      } else if (wasActive) {
        panel.classList.remove('is-active');
        panel.classList.add('is-exiting');
        window.setTimeout(function () {
          panel.classList.remove('is-exiting');
        }, 1000);
      } else {
        panel.classList.remove('is-active', 'is-exiting');
      }
    });

    var nextHeading =
      index === null
        ? this.defaultHeading
        : this.cards[index].getAttribute('data-moves-heading') || this.defaultHeading;

    this.swapHeading(nextHeading, instant);
  };

  MovesNew.prototype.applyCta = function (index) {
    this.selected = index;

    var href = this.defaultCtaHref;
    var card = index !== null ? this.cards[index] : null;
    if (card) {
      var cardHref = card.getAttribute('data-moves-link');
      if (cardHref) href = cardHref;
    }
    if (this.cta) this.cta.setAttribute('href', href || '#');

    this.cards.forEach(function (el, i) {
      var on = i === index;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  MovesNew.prototype.swapHeading = function (text, instant) {
    var el = this.headingEl;
    if (!el) return;

    if (instant || this.reducedMotion) {
      el.innerHTML = '<em></em>';
      el.querySelector('em').textContent = text;
      el.classList.remove('is-swap-out', 'is-swap-in');
      return;
    }

    if (this.headingTimer) {
      window.clearTimeout(this.headingTimer);
      this.headingTimer = null;
    }

    el.classList.add('is-swap-out');
    var self = this;
    this.headingTimer = window.setTimeout(function () {
      el.innerHTML = '<em></em>';
      el.querySelector('em').textContent = text;
      el.classList.remove('is-swap-out');
      el.classList.add('is-swap-in');
      el.offsetHeight;
      el.classList.remove('is-swap-in');
      self.headingTimer = null;
    }, EASE_MS);
  };

  MovesNew.prototype.destroy = function () {
    if (this.revealObserver) this.revealObserver.disconnect();
    if (this.headingTimer) window.clearTimeout(this.headingTimer);
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new MovesNew(root));
  }

  function destroyRoot(root) {
    if (!root || !instances.has(root)) return;
    instances.get(root).destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]')
      .forEach(initRoot);
  }

  function findRoot(sectionEl) {
    if (!sectionEl) return null;
    if (sectionEl.matches && sectionEl.matches('[data-section-type="' + SECTION_TYPE + '"]')) {
      return sectionEl;
    }
    return sectionEl.querySelector
      ? sectionEl.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
      : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  if (document.readyState !== 'loading') {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = findRoot(event.target);
    if (!root) return;
    destroyRoot(root);
    initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRoot(event.target);
    if (root) destroyRoot(root);
  });
})();
